<template>
  <div class="discussion-page full-width">
    <DiscussionAttempt
      v-for="(comment, commentIndex) in comments"
      :key="comment.id"
      v-bubble.snackbar.error.refresh-discussion-comments.populate-comments.delete-comment
      v-bind="$props"
      :comment="comment"
      :interaction.sync="localInteraction"
      :interaction-attempt.sync="localInteractionAttempt"
      :is-processing-data.sync="localIsProcessingData"
      :root-teacher="rootTeacher"
      :class="{
        'pb-2': commentIndex !== comments.length - 1
      }"
    />
  </div>
</template>

<script>
import moment from 'moment';
import api from '../../../services/api';
import DiscussionAttempt from './DiscussionAttempt.vue';
import Interaction from '../../../mixins/Interaction';

export default {
  name: 'DiscussionPage',
  components: {
    DiscussionAttempt,
  },
  mixins: [
    Interaction,
  ],
  props: {
    pageIndex: Number,
    containsSearchResults: Boolean,
    comments: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    isIntersecting: false,
    timestampOfLastApiCall: moment(),
  }),
  computed: {
    highestCommentId() {
      return this.$_.maxBy(this.comments, 'id').id;
    },
  },
  methods: {
    async populateDiscussionPage() {
      try {
        if (this.localIsProcessingData) return false;
        this.timestampOfLastApiCall = moment();
        this.localIsProcessingData = true;
        const { data: comments } = await api.getDiscussionComments({
          displayTimeGreaterThan: this.comments[0].displayTime,
          displayTimeLessThan: this.comments[this.comments.length - 1].displayTime,
          idGreaterThan: this.highestCommentId,
        });
        this.$emit('populate-comments', comments);
        return true;
      } catch(e) {
        this.$emit('error', e);
        return false;
      } finally {
        this.localIsProcessingData = false;
      }
    },
    async handleIntersectionObserver([event = {}] = []) {
      this.isIntersecting = event.isIntersecting;
      await this.$timer(3000);
      const secondsBetween = moment.duration(moment().diff(this.timestampOfLastApiCall)).asSeconds();
      if (
        this.isIntersecting
        && secondsBetween >= this.$constants.commentPopulationDebounceLimitInSeconds
      ) {
        this.populateDiscussionPage();
        return true;
      }
      return false;
    },
    initIntersectionObserver() {
      this.observer = new IntersectionObserver(this.handleIntersectionObserver, {
        root: this.$el.closest('.discussion-comments-wrapper'),
      });
      this.observer.observe(this.$el);
    },
  },
  async mounted() {
    await this.$nextTick();
    if (!this.containsSearchResults) this.initIntersectionObserver();
  },
};
</script>